export default {
  "content": "<path d=\"M10.336 17.057a2 2 0 003.328 0l5.263-7.895c.886-1.329-.067-3.11-1.664-3.11H6.737c-1.597 0-2.55 1.781-1.664 3.11l5.263 7.895z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};